import { Sun, Moon, Monitor, Check } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'
import { useLanguage } from '../contexts/LanguageContext'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'

const OPTIONS = [
  { value: 'light', icon: Sun, en: 'Light', ka: 'ნათელი' },
  { value: 'dark', icon: Moon, en: 'Dark', ka: 'მუქი' },
  { value: 'system', icon: Monitor, en: 'System', ka: 'სისტემური' },
]

/**
 * Theme switcher shown in page headers. Trigger reflects the active theme
 * (sun/moon); the menu offers Light / Dark / System. Default is System.
 */
const ThemeMenu = ({ className = '' }) => {
  const { theme, setTheme, resolvedTheme } = useTheme()
  const { language } = useLanguage()
  const TriggerIcon = resolvedTheme === 'dark' ? Moon : Sun

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={language === 'ka' ? 'თემა' : 'Theme'}
          data-testid="theme-menu"
          className={`inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-[#4a3d66] shadow-celebrate-sm transition-all duration-200 hover:-translate-y-0.5 hover:text-[#ff4d8d] hover:shadow-celebrate-md motion-reduce:transition-none motion-reduce:hover:translate-y-0 dark:bg-[#1e1438] dark:text-[#c3b8dd] dark:hover:text-white ${className}`.trim()}
        >
          <TriggerIcon className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {OPTIONS.map((opt) => {
          const Icon = opt.icon
          return (
            <DropdownMenuItem
              key={opt.value}
              onClick={() => setTheme(opt.value)}
              className="cursor-pointer"
              data-testid={`theme-option-${opt.value}`}
            >
              <Icon className="mr-2 h-4 w-4" />
              <span>{language === 'ka' ? opt.ka : opt.en}</span>
              {theme === opt.value && <Check className="ml-auto h-4 w-4" />}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ThemeMenu
